import 'core-js';
import React from 'react';
import ReactDOM from 'react-dom';
import './App.scss';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import {Provider} from "react-redux";
import {applyMiddleware, createStore} from "redux";
import {BrowserRouter} from "react-router-dom";
import {isLive} from "./lib/tools";
import reduxLogger from "redux-logger";
import moment from "moment";
import "moment/locale/da";
import {errorMiddleware, globalStateMiddleware, reducer} from "./globalState";
import RouterContext from "react-router-dom/es/RouterContext";
import {Reporter} from "./errorHandling";

const testing = false;
const loaded = new Date();

moment.locale("da");

const store = createStore(
	reducer,
	!isLive() && testing ?
		applyMiddleware(globalStateMiddleware, errorMiddleware, reduxLogger) :
		applyMiddleware(globalStateMiddleware, errorMiddleware)
);

ReactDOM.render(
	<Provider store={store}>
		<BrowserRouter>
			<RouterContext.Provider value={{route: "/"}}>
				<Reporter startTime={loaded}>
					<App/>
				</Reporter>
			</RouterContext.Provider>
		</BrowserRouter>
	</Provider>,
	document.getElementById('root'));

if (!isLive()) registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js